/**
 * Font Awesome configuration file
 * This file sets up the Font Awesome library and icons used in the application
 */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCamera,
  faPen,
  faXmark,
  faStar,
} from '@fortawesome/free-solid-svg-icons'

// Add icons to the library
library.add(faCamera, faPen, faXmark, faStar)

/**
 * Registers Font Awesome with Vue
 * @param {Object} app - The Vue application instance
 */
export const registerFontAwesome = (app) => {
  app.component('font-awesome-icon', FontAwesomeIcon)
}
